import { render, staticRenderFns } from "./AgenciesStats.vue?vue&type=template&id=71d6daac"
import script from "./AgenciesStats.vue?vue&type=script&lang=js"
export * from "./AgenciesStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports